import React from 'react'
import { useEffect, useRef, useState } from 'react'
export default function StatisticalReportPage(props) {
  const iframeRef = useRef(null)
  const [iframeHeight, setIframeHeight] = useState('auto')

  useEffect(() => {
    const handleMessage = (event) => {
      if (event.origin.includes('neureader.net')) {
        setIframeHeight(event.currentTarget.innerHeight + 100 + 'px')
      }
    }
    window.addEventListener('message', handleMessage)
    return () => window.removeEventListener('message', handleMessage)
  }, [])
  return (
    <div className="flex flex-col gap-4">
      <h1>Báo cáo thống kê</h1>
      <iframe
        ref={iframeRef}
        src={process.env.REACT_APP_STATISTIC_URL}
        style={{ width: '100%', border: 'none', height: iframeHeight }}
      />
    </div>
  )
}
